<app-header-title>
  <span title>طلب إجازة</span>
</app-header-title>

<div class="publicsetting" style="padding: 0rem 3rem;">
  <dx-form [formData]="model" labelMode="floating" labelLocation="top" colCount="2">
    
    <!-- الموظف -->
    <dxi-item
      dataField="employeeId"
      editorType="dxSelectBox"
      [editorOptions]="{
        dataSource: employeeDropDown,
        valueExpr: 'id',
        displayExpr: 'nameAr',
        searchEnabled: true,
        showClearButton: true,
        onValueChanged: onEmployeeChanged
      }">
      <dxo-label text="الموظف"></dxo-label>
      <dxi-validation-rule type="required" message="الموظف مطلوب"></dxi-validation-rule>
    </dxi-item>

    <!-- نوع الإجازة -->
    <dxi-item 
      dataField="holidayTypeId" 
      editorType="dxSelectBox"
      [editorOptions]="{
        dataSource: HolidayTypeDropDown,
        valueExpr: 'id',
        displayExpr: 'nameAr',
        searchEnabled: true,
        showClearButton: true,
        disabled: !model.employeeId,
        onValueChanged: onFieldChanged
      }">
      <dxo-label text="نوع الإجازة"></dxo-label>
      <dxi-validation-rule type="required" message="نوع الإجازة مطلوب"></dxi-validation-rule>
    </dxi-item>
    
    <!-- تاريخ البداية -->
    <dxi-item 
      dataField="startDate" 
      editorType="dxDateBox" 
      [editorOptions]="{ 
        type: 'date',
        onValueChanged: onFieldChanged
      }">
      <dxo-label text="من"></dxo-label>
      <dxi-validation-rule type="required" message="تاريخ البداية مطلوب"></dxi-validation-rule>
    </dxi-item>

    <!-- تاريخ النهاية -->
    <dxi-item 
      dataField="endDate" 
      editorType="dxDateBox" 
      [editorOptions]="{ 
        type: 'date',
        onValueChanged: onFieldChanged
      }">
      <dxo-label text="إلى"></dxo-label>
      <dxi-validation-rule type="required" message="تاريخ النهاية مطلوب"></dxi-validation-rule>
    </dxi-item>

    <!-- سبب الإجازة -->
    <dxi-item 
      dataField="vacationReson" 
      colSpan="2" 
      editorType="dxTextArea"
      [editorOptions]="{ 
        height: 90,
        onValueChanged: onFieldChanged
      }">
      <dxo-label text="سبب الإجازة"></dxo-label>
      <dxi-validation-rule type="required" message="سبب الإجازة مطلوب"></dxi-validation-rule>
    </dxi-item>
  </dx-form>

  <div style="display:flex; gap:12px; margin-top:16px;">
    <dx-button 
      text="تحقق" 
      type="default" 
      [disabled]="isChecking" 
      (onClick)="checkAvailability()">
    </dx-button>
    <dx-button 
      text="إرسال الطلب" 
      type="success"
      [disabled]="!isValid || isSubmitting"
      (onClick)="submit()">
    </dx-button>
  </div>

  <hr class="my-4">
<div class="bulk-section" style="padding: 1.5rem; background: #fcfcfc; border-radius: 12px; border: 1px solid #eee;">
  
<div style="display: flex; align-items: center; gap: 15px; padding: 15px 25px; background: #fff; border-radius: 12px; border: 2px dashed #337ab7; width: fit-content; box-shadow: 0 4px 12px rgba(0,0,0,0.05); margin-bottom: 25px;">
  
  <input 
    type="file" 
    (change)="onFileUploaded($event)" 
    accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
    id="excelUpload" 
    style="display:none" />


  <dx-button 
    text="استيراد من إكسل" 
    icon="xlsxfile" 
    type="success" 
    [stylingMode]="'outlined'" 
    [disabled]="isUploadingBulk" 
    (onClick)="triggerUpload()">
  </dx-button>

 
  <dx-button 
    text="تحميل القالب" 
    icon="download" 
    type="normal" 
    [stylingMode]="'outlined'" 
    (onClick)="downloadTemplate()">
  </dx-button>

  <div *ngIf="isUploadingBulk" style="display: flex; align-items: center; gap: 8px;">
    <i class="dx-icon-refresh dx-icon-spin" style="color: #337ab7;"></i>
    <span style="font-size: 14px; color: #337ab7; font-weight: 600;">جاري المعالجة...</span>
  </div>
</div>

  <div *ngIf="bulkResults" style="margin-top:20px;">
    <dx-tab-panel [selectedIndex]="bulkResults.failedCount > 0 ? 1 : 0" [animationEnabled]="true">
      
      <dxi-item title="الناجحة ({{bulkResults.successCount}})" icon="check">
        <div style="padding: 15px;">
          <dx-data-grid 
            [dataSource]="bulkResults.successItems" 
            [showBorders]="true" 
            [height]="300"
            [columnAutoWidth]="true">
            <dxi-column dataField="employeeId" caption="كود الموظف"></dxi-column>
            <dxi-column dataField="startDate" caption="من" dataType="date"></dxi-column>
            <dxi-column dataField="endDate" caption="إلى" dataType="date"></dxi-column>
            <dxi-column dataField="holidayTypeId" caption="نوع الإجازة"></dxi-column>
            <dxi-column dataField="vacationReson" caption="السبب"></dxi-column>
          </dx-data-grid>
        </div>
      </dxi-item>
<dxi-item title="الأخطاء ({{bulkResults.failedCount}})" icon="close">
  <div style="padding: 15px;">
    <dx-button 
      *ngIf="bulkResults.failedCount > 0"
      text="تصدير الأخطاء لإعادة التعديل" 
      icon="exportxlsx" 
      type="danger" 
      [stylingMode]="'text'"
      (onClick)="exportFailedRows()">
    </dx-button>

    <dx-data-grid 
      [dataSource]="bulkResults.errors" 
      [showBorders]="true" 
      [height]="400"
      [columnAutoWidth]="true"
      [wordWrapEnabled]="true">
      
      <dxi-column dataField="rowIndex" caption="السطر" [width]="70" alignment="center" [fixed]="true"></dxi-column>
      
      <dxi-column dataField="rowData.employeeId" caption="كود الموظف" [width]="100"></dxi-column>
      <dxi-column dataField="rowData.startDate" caption="من" dataType="date" [width]="110"></dxi-column>
      <dxi-column dataField="rowData.endDate" caption="إلى" dataType="date" [width]="110"></dxi-column>
      <dxi-column dataField="rowData.holidayTypeId" caption="النوع" [width]="80"></dxi-column>
      
      <dxi-column dataField="errors" caption="لماذا فشل؟" cellTemplate="errorTemplate"></dxi-column>
      
      <div *dxTemplate="let data of 'errorTemplate'">
        <div *ngFor="let err of data.value" style="color:#d9534f; font-weight: 500; font-size: 12px;">
          • {{err}}
        </div>
      </div>
    </dx-data-grid>
  </div>
</dxi-item>

    </dx-tab-panel>
  </div>
</div>
</div>